import useCountdownTimer from '@/modules/perseo-billing/hooks/use-timer-count-down';
import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';

interface ITimer {
  transactionCountdown: number;
}

export default function Timer({ transactionCountdown }: ITimer) {
  const {
    time: { formatted }
  } = useCountdownTimer(transactionCountdown);

  return (
    <Typography weight="semibold" className="!co-text-[20px]">
      {formatted}
    </Typography>
  );
}
